import { gql } from '@apollo/client';

export const USER_LOGIN = gql`
    mutation UserLogin($loginUserInput: LoginUserInput!) {
        userLogin(loginUserInput: $loginUserInput) {
            userData {
                companyId
                inCompany
                token {
                    accessToken
                    accessTokenExpiresIn
                    refreshToken
                    refreshTokenExpiresIn
                }
                user {
                    _id
                    acceptedEmailCommunication
                    acceptedTAndC
                    companyCreator
                    email
                    firstName
                    jobTitle
                    lastLoggedInAt
                    lastName
                    mobileNum
                    plan
                    profileImage
                    receiveNotification
                    registeredWithGoogle
                    stripeCustomerId
                    subscriptionRenewable
                    subscriptionStatus
                    hasClickedIntegrationButton
                    hasViewedIntegrationModal
                    userName
                    verifiedAt
                }
            }
            otpData {
                message
                otpExpiresAt
            }
        }
    }
`;

export const VERIFY_EMAIL_OTP = gql`
    mutation VerifyEmailOtp($verifyEmailOtpInput: VerifyEmailOtpInput!) {
        verifyEmailOtp(verifyEmailOtpInput: $verifyEmailOtpInput) {
            userData {
                companyId
                inCompany
                token {
                    accessToken
                    accessTokenExpiresIn
                    refreshToken
                    refreshTokenExpiresIn
                }
                user {
                    _id
                    acceptedEmailCommunication
                    acceptedTAndC
                    companyCreator
                    email
                    firstName
                    jobTitle
                    lastLoggedInAt
                    lastName
                    mobileNum
                    plan
                    profileImage
                    receiveNotification
                    registeredWithGoogle
                    stripeCustomerId
                    subscriptionRenewable
                    subscriptionStatus
                    userName
                    verifiedAt
                }
            }
        }
    }
`;

export const SEND_EMAIL_OTP = gql`
    mutation SendEmailOtp($sendEmailOtpInput: SendEmailOtpInput!) {
        sendEmailOtp(sendEmailOtpInput: $sendEmailOtpInput) {
            message
            otpExpiresAt
        }
    }
`;

export const GOOGLE_LOGIN = `mutation LoginWithGoogle($googleToken: GoogleLoginInput!) {
  loginWithGoogle(googleToken: $googleToken) {
    otpData {
      message
      otpExpiresAt
    }
    userData {
      companyId
      inCompany
      user {
        _id
        acceptedEmailCommunication
        acceptedTAndC
        companyCreator
        email
        firstName
        jobTitle
        lastLoggedInAt
        lastName
        mobileNum
        plan
        profileImage
        receiveNotification
        registeredWithGoogle
        stripeCustomerId
        subscriptionRenewable
        subscriptionStatus
        userName
        verifiedAt
      }
      token {
        accessToken
        accessTokenExpiresIn
        refreshToken
        refreshTokenExpiresIn
      }
    }
  }
}`;

export const CREATE_QUESTION_REGISTRY = gql`
    mutation AddQuestionRegistry($addQuestionRegistryInput: AddQuestionRegistryInput!) {
        addQuestionRegistry(addQuestionRegistryInput: $addQuestionRegistryInput) {
            status
        }
    }
`;

export const SELECT_COMPANY_LOGIN = gql`
    mutation SelectCompanyForLogin($companyId: String!, $fingerprint: String!) {
        selectCompanyForLogin(companyId: $companyId, fingerprint: $fingerprint) {
            userData {
                companyId
                inCompany
                isInviteTeamSkipped
                quantity
                token {
                    accessToken
                    accessTokenExpiresIn
                    refreshToken
                    refreshTokenExpiresIn
                }
                user {
                    _id
                    acceptedEmailCommunication
                    acceptedTAndC
                    companyCreator
                    email
                    firstName
                    jobTitle
                    lastLoggedInAt
                    lastName
                    mobileNum
                    plan
                    profileImage
                    receiveNotification
                    registeredWithGoogle
                    stripeCustomerId
                    subscriptionRenewable
                    subscriptionStatus
                    userName
                    verifiedAt
                    hasClickedIntegrationButton
                    hasViewedIntegrationModal
                    hasClickedIntegrationButton
                }
            }
        }
    }
`;

export const VERIFY_NON_USER = gql`
    mutation VerifyNonUser($email: String!) {
        verifyNonUser(email: $email) {
            email
        }
    }
`;
